import { render } from "./UserExpensesSection.vue?vue&type=template&id=c0ebd8b6&scoped=true&ts=true&lang=pug"
import script from "./UserExpensesSection.vue?vue&type=script&lang=ts"
export * from "./UserExpensesSection.vue?vue&type=script&lang=ts"

import "./UserExpensesSection.vue?vue&type=style&index=0&id=c0ebd8b6&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Esse Group/CMS Admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0ebd8b6"]])

export default __exports__